angular.module("ainapp")
    .controller("stockFOCReportController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Stock FOC Report";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Brands = [];
            MainService.BrandsInDropdown().then(function (response) {
                var temp = {
                    Id: "",
                    Name: "All",
                }
                $scope.Brands = response.data;
                $scope.Brands.push(temp);
            }, function (err) {
                toastr.error("Network Error");
            })

            $scope.Categories = [];
            MainService.ProductsParentList("Product").then(function (response) {
                $scope.Categories = response.data;
            });

            $scope.GetSub = function () {
                $scope.Parents = [];
                MainService.ProductSubList($scope.filter.ProductGroupId, "Product").then(function (response) {
                    $scope.Parents = response.data;
                });
            }

            $scope.Branches = [];
            MainService.BranchesInDropdown().then(function (response) {
                var temp = {
                    Id: "",
                    Name: "All",
                }
                $scope.Branches = response.data;
                $scope.Branches.push(temp);
            }, function (err) {
                toastr.error("Network Error");
            })

            $scope.productSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {

                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length == 0) {
                                var temp = {
                                    value: "",
                                    operator: "contains",
                                    field: "Name",
                                    ignoreCase: true
                                };
                                o.data.filter.filters.push(temp);
                            }
                        }

                        MainService.productForMultiSelect(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            //toastr.error("NetworkError");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 50
            };

            $scope.selectProductsOptions = {
                placeholder: "Select Products...",
                dataTextField: "Name",
                filter: "contains",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.productSelectDataSource
            };

            $scope.selectProductCodeOptions = {
                placeholder: "Select Product Codes...",
                dataTextField: "ProductCode",
                dataValueField: "Id",
                filter: "contains",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.productSelectDataSource
            };


            $scope.warehouseSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        MainService.WarehouseInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            //toastr.error("NetworkError");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 20
            };

            $scope.selectWarehouseOptions = {
                placeholder: "Select Warehouse...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.warehouseSelectDataSource
            };

            $scope.initDetailReport = function () {

                $scope.ColumnDetails = [
                    {
                        field: "StockFOC.VoucherNo",
                        title: "Doc No #",
                        width: "120px",
                    },
                    {
                        field: "StockFOC.Date",
                        title: "Doc Date",
                        template: "#= kendo.toString(kendo.parseDate(StockFOC.Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        width: "120px",

                    },
                    {
                        field: "Product.Name",
                        title: "Product",
                        width: "100px",
                    },
                    {
                        field: "Unit.Name",
                        title: "Unit",
                        width: "100px",
                    },
                    {
                        field: "Quantity",
                        title: "Quantity",
                        width: "160px",
                        aggregates: ["sum"],
                        // footerTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(Quantity, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Quantity</div>")
                    },
                    {
                        field: "UnitPrice",
                        title: "Unit Price",
                        width: "120px",
                        template: "<div style='text-align: right'>#=kendo.toString(UnitPrice, 'n')#</div>",
                        headerTemplate: kendo.template("<div class='headerright'>Unit Price</div>")
                    },
                    {
                        field: "TotalAmount",
                        title: "TotalAmount",
                        width: "160px",
                        aggregates: ["sum"],
                        // footerTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(TotalAmount, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Total</div>")
                    },
                    {
                        field: "Remark",
                        title: "Remark",
                        width: "120px",
                    },

                ];


                $scope.CostCenters = [];
                MainService.CostCentersInReortVoucher("Stock FOC").then(function (response) {
                    $scope.CostCenters = response.data;

                    angular.forEach($scope.CostCenters, function (e) {
                        var field = e.CostCenter.Name.replace(/ /g, '');
                        field = field.replace('&', '');
                        field = field.replace('/', '');
                        field = field.replace('.', '');

                        var clm = {
                            title: e.CostCenter.Name,
                            field: "CC" + field,
                            width: '100px',
                        }
                        $scope.ColumnDetails.push(clm);
                    })

                    var options = {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-eye'  ng-click='View(dataItem)'></button> <button class=' btn-default btn-sm fa fa-print'  ng-click='PrintInvoice(dataItem.StockFOC.Id, \"Stock FOC\", dataItem.StockFOC.VoucherNo)'></button>",
                        width: '100px',
                        sticky: true
                    };

                    $scope.ColumnDetails.push(options);

                    $scope.loadDetailReport();
                });

            }

            $scope.initSummaryReport = function () {

                $scope.ColumnSumamry = [
                    {
                        field: "VoucherNo",
                        title: "Doc No #",
                        width: "120px",
                    },
                    {
                        field: "Date",
                        title: "Doc Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        width: "120px",
                    },
                    {
                        field: "TotalQuantity",
                        title: "Total Quantity",
                        width: "160px",
                        aggregates: ["sum"],
                        // footerTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(TotalQuantity, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Total Quantity</div>")
                    },
                    {
                        field: "TotalAmount",
                        title: "Total Amount",
                        width: "160px",
                        aggregates: ["sum"],
                        // footerTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(TotalAmount, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Total Amount</div>")
                    },
                    {
                        field: "Warehouse.Name",
                        title: "Warehouse",
                        width: "100px",
                    },
                    {
                        field: "Remark",
                        title: "Remark",
                        width: "120px",
                    },


                ];


                $scope.CostCenters = [];
                MainService.CostCentersInReortVoucher("Stock FOC").then(function (response) {
                    $scope.CostCenters = response.data;

                    angular.forEach($scope.CostCenters, function (e) {
                        var field = e.CostCenter.Name.replace(/ /g, '');
                        field = field.replace('&', '');
                        field = field.replace('/', '');
                        field = field.replace('.', '');

                        var clm = {
                            title: e.CostCenter.Name,
                            field: "CC" + field,
                            width: '100px',
                        }
                        $scope.ColumnSumamry.push(clm);
                    })

                    var options = {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-eye'  ng-click='View(dataItem)'></button> <button class=' btn-default btn-sm fa fa-print'  ng-click='PrintInvoice(dataItem.Id, \"Stock FOC\", dataItem.VoucherNo)'></button>",
                        width: '100px',
                        sticky: true
                    };

                    $scope.ColumnSumamry.push(options);

                    $scope.loadSummaryReport();
                });

            }





            $scope.loadSummaryReport = function () {
                $scope.KendoSource = new kendo.data.DataSource({
                    batch: true,
                    transport: {
                        read: function (o) {

                            if ($scope.filter.isLoad) {


                               o.data.FromDate = $scope.filter.FromDate;
                                o.data.ToDate = $scope.filter.ToDate;
                                o.data.ProductIds = $scope.filter.ProductIds;
                                o.data.WarehouseIds = $scope.filter.WarehouseIds;
                                o.data.Keyword = $scope.filter.Keyword;
                                o.data.BranchId = $scope.filter.BranchId;
                                o.data.ProductGroupId = $scope.filter.ProductGroupId;
                                o.data.ProductParentId = $scope.filter.ProductParentId;

                                o.data.FromDateString = $scope.extractDate($scope.filter.FromDate);
                                o.data.ToDateString = $scope.extractDate($scope.filter.ToDate);
                                o.data.CostCenters = $scope.CostCenters;

                                MainService.StockFOCSummaryReport(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("NetworkError");
                                })
                            } else {
                                o.success({
                                    Data: []
                                });
                            }

                        },

                    },
                    change: function (data) {
                        if (data.items.length > 0) {
                            console.log(data);
                            var arr = [];
                            angular.forEach($scope.CostCenters, function (e) {
                                var field = e.CostCenter.Name.replace(/ /g, '');
                                field = field.replace('&', '');
                                field = field.replace('/', '');
                                field = field.replace('.', '');
                                arr.push('CC' + field);
                            })
                            angular.forEach(data.items, function (e) {
                                angular.forEach(arr, function (ar) {

                                    angular.forEach(e.StockFOCCosts, function (a) {

                                        var afield = a.ParentName.replace(/ /g, '');
                                        afield = afield.replace('&', '');
                                        afield = afield.replace('/', '');
                                        afield = afield.replace('.', '');
                                        afield = "CC" + afield;

                                        if (afield == ar) {
                                            e[ar] = a.CostCenterName;
                                        }
                                    })


                                })
                            })
                        }
                    },
                    schema: {
                        data: "Data",
                        total: "Total",
                        model: {
                            id: "Id",
                            fields: {
                                "VoucherNo": {
                                    type: "string",
                                    editable: false,
                                },
                                "Date": {
                                    type: "date",
                                    editable: false,
                                },
                                "Warehouse.Name": {
                                    type: "number",
                                    editable: false,
                                },
                                "Remark": {
                                    type: "string",
                                    editable: false,
                                },
                                "TotalQuantity": {
                                    type: "number",
                                    editable: false,
                                },
                                "TotalAmount": {
                                    type: "number",
                                    editable: false,
                                },
                            }
                        }
                    },
                    serverPaging: true,
                    serverSorting: true,
                    serverFiltering: true,
                    pageSize: 20,
                    aggregate: [
                        {
                            field: "TotalQuantity",
                            aggregate: "sum"
                        },
                        {
                            field: "TotalAmount",
                            aggregate: "sum"
                        }
                    ],
                });

                $scope.KendoGridOptions = {
                    editable: false,
                    pageable: true,
                    toolbar: ["excel"],
                    height: 700,
                    resizable: true,
                    dataSource: $scope.KendoSource,
                    pageSize: 20,
                    pageable: {
                        input: false,
                        refresh: true,
                        pageSizes: true,
                        info: true,
                    },
                    sortable: true,
                    scrollable: true,
                    filterable: true,
                    groupable: true,
                    columnMenu: {
                        filterable: false,
                        filterable: true,
                    },
                    columns: $scope.ColumnSumamry,
                };


            }

            $scope.loadDetailReport = function () {
                $scope.KendoSource = new kendo.data.DataSource({
                    batch: true,
                    transport: {
                        read: function (o) {

                            if ($scope.filter.isLoad) {


                              o.data.FromDate = $scope.filter.FromDate;
                                o.data.ToDate = $scope.filter.ToDate;
                                o.data.ProductIds = $scope.filter.ProductIds;
                                o.data.WarehouseIds = $scope.filter.WarehouseIds;
                                o.data.Keyword = $scope.filter.Keyword;
                                o.data.BranchId = $scope.filter.BranchId;
                                o.data.ProductGroupId = $scope.filter.ProductGroupId;
                                o.data.ProductParentId = $scope.filter.ProductParentId;

                                o.data.FromDateString = $scope.extractDate($scope.filter.FromDate);
                                o.data.ToDateString = $scope.extractDate($scope.filter.ToDate);
                                o.data.CostCenters = $scope.CostCenters;
                                
                                MainService.StockFOCDetailedReport(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("NetworkError");
                                })
                            } else {
                                o.success({
                                    Data: []
                                });
                            }

                        },

                    },
                    change: function (data) {
                        if (data.items.length > 0) {
                            console.log(data);
                            var arr = [];
                            angular.forEach($scope.CostCenters, function (e) {
                                var field = e.CostCenter.Name.replace(/ /g, '');
                                field = field.replace('&', '');
                                field = field.replace('/', '');
                                field = field.replace('.', '');
                                arr.push('CC' + field);
                            })
                            angular.forEach(data.items, function (e) {
                                angular.forEach(arr, function (ar) {

                                    angular.forEach(e.StockFOCCosts, function (a) {

                                        var afield = a.ParentName.replace(/ /g, '');
                                        afield = afield.replace('&', '');
                                        afield = afield.replace('/', '');
                                        afield = afield.replace('.', '');
                                        afield = "CC" + afield;

                                        if (afield == ar) {
                                            e[ar] = a.CostCenterName;
                                        }
                                    })


                                })
                            })
                        }
                    },
                    schema: {
                        data: "Data",
                        total: "Total",
                        model: {
                            id: "Id",
                            fields: {
                                "StockFOC.VoucherNo": {
                                    type: "string",
                                    editable: false,
                                },
                                "StockFOC.Date": {
                                    type: "date",
                                    editable: false,
                                },
                                "Product.Name": {
                                    type: "string",
                                    editable: false,
                                },
                                "Unit.Name": {
                                    type: "string",
                                    editable: false,
                                },
                                Quantity: {
                                    type: "number",
                                    editable: false,
                                },
                                UnitPrice: {
                                    type: "number",
                                    editable: false,
                                },
                                TotalAmount: {
                                    type: "number",
                                    editable: false,
                                },
                                Remark: {
                                    type: "string",
                                    editable: false,
                                },
                            }
                        }
                    },
                    serverPaging: true,
                    serverSorting: true,
                    serverFiltering: true,
                    pageSize: 20,
                    aggregate: [
                        {
                            field: "Quantity",
                            aggregate: "sum"
                        },
                        {
                            field: "TotalAmount",
                            aggregate: "sum"
                        },
                    ],
                });

                $scope.KendoGridOptions = {
                    editable: false,
                    pageable: true,
                    toolbar: ["excel"],
                    height: 700,
                    resizable: true,
                    dataSource: $scope.KendoSource,
                    pageSize: 20,
                    pageable: {
                        input: false,
                        refresh: true,
                        pageSizes: true,
                        info: true,
                    },
                    sortable: true,
                    scrollable: true,
                    filterable: true,
                    groupable: true,
                    columnMenu: {
                        filterable: false,
                        filterable: true,
                    },
                    columns: $scope.ColumnDetails,
                };


            }

             $scope.$on('$includeContentLoaded', function (event, templateName) {
                if (templateName === 'templates/common/stockFilterModal.html') {
                    $('#filterModal').modal('show');
                }
            });

            $scope.Init = function () {
 
                $scope.date1 = new Date();
                var n = $scope.date1.getFullYear();
                $scope.d2 = new Date("01/01/" + n);

                $scope.filter = {
                    FromDate: $scope.d2,
                    ToDate: new Date(),
                    ProductIds: [],
                    WarehouseIds: [],
                    isLoad: false,
                    Keyword: "",
                    BranchId: "",
                }

                $scope.load = false;
                $scope.isFilter = false;


                $scope.ReportType = $stateParams.Type;
                if ($scope.ReportType == "Detail") {
                    $scope.ReportName = "Detail";
                    $scope.initDetailReport();
                } else {
                    $scope.ReportName = "Summary";
                    $scope.initSummaryReport();
                }

            }
            $scope.Init();



             $scope.OpenFilter = function () {
                $('#filterModal').modal('show');
            }

            $scope.filterData = function () {
                $scope.filter.isLoad = true;
                $('#filterModal').modal('hide');
                console.log($scope.filter)
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.refreshData = function () {
                $scope.Init();
                 $scope.filter.isLoad = false;
                $('#filterModal').modal('show');
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.Edit = function (data) {
                if ($scope.ReportType == "Detail") {
                    $state.go("editStockFOC", {
                        VoucherId: data.StockFOCId
                    })
                } else {
                    $state.go("editStockFOC", {
                        VoucherId: data.Id
                    })
                }
            }

            $scope.View = function (data) {
                if ($scope.ReportType == "Detail") {
                    $state.go("viewStockFOC", {
                        VoucherId: data.StockFOCId
                    })
                } else {
                    $state.go("viewStockFOC", {
                        VoucherId: data.Id
                    })
                }
            }


            $scope.print = function () {

                $scope.filter.FromDateString = $scope.extractDate($scope.filter.FromDate);
                $scope.filter.ToDateString = $scope.extractDate($scope.filter.ToDate);

                $scope.filter.CostCenters = $scope.CostCenters;

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                if ($scope.ReportType == "Detail") {

                    MainService.PrintStockFOCDetailedReport($scope.filter).then(function (response) {
                        if (response.data != null) {
                            $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })

                } else {

                    MainService.PrintStockFOCSummaryReport($scope.filter).then(function (response) {
                        if (response.data != null) {
                            $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })

                }

            }


        }])
